import { Flex } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

import { OFText } from "design_system/components/OFText";
import { addTransSuffixCountry } from "src/utils";
import { formatPrice } from "src/utils/priceFormat";

type Props = {
  summary: any;
};

export const DueNowRow = ({ summary }: Props) => {
  const { t } = useTranslation();
  return (
    <Flex justifyContent="space-between" my="0px 12px">
      <OFText textStyle="body1semibold">
        {t(`${addTransSuffixCountry("checkout")}:total-label`)}
      </OFText>
      <OFText textStyle="body1semibold">{formatPrice(summary?.totalNowAfterCashback || 0)}</OFText>
    </Flex>
  );
};
